<template>
    <div style="position:relative">
        <div class="bigBody">
            <div class="smallBody" :style="'width:' + ( width*8) + 'rem'">
                <div class="smallHead">{{width}}%</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Loading",
        props: ["width"],
        data() {
            return {
                url: '',
                loadEnd: false
            }
        },
        mounted() {},
        beforeDestroy() {},
        methods: {}
    }
</script>

<style lang='less' scoped>
    .bigBody {
        width: 800rem;
        height: 8rem;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 4rem;

        .smallBody {
            width: 15rem;
            height: 8rem;
            background: #0D94FF;
            position: relative;
            border-radius: 4rem;
        }

        .smallHead {
            width: 80rem;
            height: 5rem;
            position: absolute;
            right: -2vw;
            top: -5.1vh;
            text-align: center;
            
        }
        .smallHead::after{
                content: '';
                width: 100rem ;
                height: 100rem;
                position: absolute;
                top: 0.9vh;
                left: -0.7vw;
                background: url(../../assets/img/bloom.png);
                background-size: 100% 100%;
            }
    }

    .bigHead {
        width: 22rem;
        height: 40rem;
        background: url(../../assets/img/大电池盖子.png);
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        top: 0;
    }
</style>